// removed by extract-text-webpack-plugin
module.exports = {"icheckbox_square-blue":"blue__icheckbox_square-blue--H6Hdg","checked":"blue__checked--23alN"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/icheck/square/blue.css
// module id = ./src/styles/icheck/square/blue.css
// module chunks = 2